<template>
    <div class="flex-1 flex flex-col">
        <div class="right_tip">
            <img class="absolute w-[250px] h-[162px] left-[29px] top-0 z-10" src="@/assets/img_bg.png"/>
            <div
                class="flex1 flex flex-col justify-center w-[100%] bg-white pl-[327px] absolute bottom-0 sm:min-h-[120px] rounded-[15px] text-[#333333]"
            >
                <p class="text-[32px]">Hello！<label class="text-2xl">我是MedliveGPT</label></p>
                <p class="text-sm">
                    能够学习和理解人类的语言，进行多轮对话 <br />
                    回答问题，高效便捷地帮助人们获取信息、知识和灵感
                </p>
            </div>
        </div>
        <div class="shili_box flex-1">
            <!-- <div class="shili_box_one">
                <div class="flex flex-col gap-y-5 border-r border-[#C2C4CB]">
                    <div class="text-center text-2xl">
                        <div class="text-center">
                            <img src="@/assets/icon1.png" class="w-[46px] h-[46px] mb-[14px]" />
                        </div>
                        示例
                    </div>
                    <div v-for="(item, key) in exampleList" :key="key" class="shili_item" @click="clickExample(item)">
                        {{ item }} →
                    </div>
                </div>
                <div class="flex flex-col gap-y-4">
                    <div class="text-center text-2xl flex-col">
                        <div class="text-center">
                            <img src="@/assets/icon2.png" class="w-[46px] h-[46px] mb-[14px]" />
                        </div>
                        限制
                    </div>
                    <div v-for="(item, key) in tipList" :key="key" class="shili_item" >
                        {{ item }} →
                    </div>
                </div>
            </div> -->
            <p class="try_ask">你可以尝试问我</p>       
            <!--默认推荐问题-->
            <div class="list_box recommend_list_box gap-x-3">
                <div class="one_recommend" 
                    v-for="(item, index) in recList" 
                    :key="index" 
                    :title="item.title"
                    @click="clickRecommend(item.title)">
                    <p class="overflow-hidden text-ellipsis line-clamp-3">
                        <b>{{ item.cate }}：</b>{{ item.title }}
                    </p>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            recList: [], //默认推荐列表
        }
    },
    mounted() {
        this.getRecList()
    },
    methods: {
        getRecList() {
            let params = {
                token: window.localStorage.getItem('token'),
            }
            this.$api.putforwardList(params).then(res => {
                this.recList = res.data
            })
        },
        clickRecommend(item) {
            this.$emit('handleClick', 'shili', item)
        }
    }
};
</script>

<style class='scss' scoped>
.right_tip {
    @apply relative max-sm:flex flex-row w-full sm:min-h-[162px] h-[120px] rounded-[15px];
}
.shili_box {
    @apply w-full h-full pt-6 sm:pt-10 sm:px-0;
}
/* .shili_box_one {
    @apply grid grid-cols-1 gap-y-10 sm:grid-cols-2 sm:gap-x-6 text-[#333333];
}
.shili_item {
    @apply text-base p-2 rounded-md text-center hover:bg-gray-200;
} */
.try_ask{
    background: url(@/assets/icon_qa.png) no-repeat left center;
    background-size: 16px 16px;
    @apply text-base text-[#333333] pl-[23px];
}
/* .switch_dep{
    background: url(@/assets/icon_change.png) no-repeat left center;
    background-size: 18px 18px;
    @apply w-[18px] h-[18px];
}
.switch_dep:hover{
    background: url(@/assets/icon_change_c.png) no-repeat left center;
    background-size: 18px 18px;
} */
.list_box{
    @apply w-[100%] min-h-[316px] bg-white mt-5 rounded-[15px];
}
.recommend_list_box{
    @apply pt-5 px-5 pb-2 flex flex-row justify-start flex-wrap;
}
.one_recommend{
    width: calc((100% - 32px) / 3);
    min-width: calc((100% - 32px) / 3);
    max-width: calc((100% - 32px) / 3);
    @apply flex-1 bg-[#F6F9FE] mr-1 mb-3 p-3 text-sm text-[#333333] rounded-[15px] cursor-pointer;
}
.one_recommend:hover{
    @apply bg-[#E8EFFA] text-[#4C5BDF];
}
.one_recommend:nth-child(3n){
    @apply mr-0;
}
</style>